import React from "react";
import { useRecoilState } from "recoil";
import { userState } from "../states/userState";
import { User } from "../components/types/user";
import { setUserToLocalStorage } from "../functions/localStorageManager";
import { Columns } from "../components/types/user";
import {
  VIEW_ID_5253,
  VIEW_ID_54,
  VIEW_ID_ALL_FACTORY,
  VIEW_ID_PT,
  VIEW_ID_PV,
} from "../commons/views";
export const useUserStateLocalstorage = () => {
  const [user, setUser] = useRecoilState<User>(userState);
  const getColumns = (viewId: number) => {
    return viewId === VIEW_ID_ALL_FACTORY
      ? user.columnsAllFactory
      : viewId === VIEW_ID_PT
      ? user.columnsPT
      : viewId === VIEW_ID_PV
      ? user.columnsPV
      : viewId === VIEW_ID_54
      ? user.columnsKanto
      : viewId === VIEW_ID_5253
      ? user.columnsFukuokaKumamoto
      : user.columnsSite;
  };

  const updateColumnsOrder = (columnOrder: any) => {
    const columns = getColumns(user.viewId);

    // console.log("columns", columns, "columnOrder", columnOrder);
    const newColumns = [...columns].sort((a, b) => {
      const indexA = columnOrder.indexOf(a.columnId);
      const indexB = columnOrder.indexOf(b.columnId);
      return indexA - indexB;
    });
    setUser((prevState: User) => {
      const newUser = {
        ...prevState,
        columnsAllFactory:
          user.viewId === VIEW_ID_ALL_FACTORY
            ? newColumns
            : prevState.columnsAllFactory,
        columnsPT:
          user.viewId === VIEW_ID_PT ? newColumns : prevState.columnsPT,
        columnsPV:
          user.viewId === VIEW_ID_PV ? newColumns : prevState.columnsPV,
        columnsKanto:
          user.viewId === VIEW_ID_54 ? newColumns : prevState.columnsKanto,
        columnsFukuokaKumamoto:
          user.viewId === VIEW_ID_5253
            ? newColumns
            : prevState.columnsFukuokaKumamoto,
        columnsSite:
          user.viewId !== VIEW_ID_ALL_FACTORY &&
          user.viewId !== VIEW_ID_PT &&
          user.viewId !== VIEW_ID_PV &&
          user.viewId !== VIEW_ID_54 &&
          user.viewId !== VIEW_ID_5253
            ? newColumns
            : prevState.columnsSite,
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const updateColumnsVisibility = (columnVisibility: any) => {
    const columns = getColumns(user.viewId);
    // console.log("columns", columns, "columnVisibility", columnVisibility);
    const newColumns = columns.map((column: Columns) => {
      const newColumn = { ...column };
      newColumn.isShow = columnVisibility[column.columnId];
      return newColumn;
    });
    setUser((prevState: User) => {
      const newUser = {
        ...prevState,
        columnsAllFactory:
          user.viewId === VIEW_ID_ALL_FACTORY
            ? newColumns
            : prevState.columnsAllFactory,
        columnsPT:
          user.viewId === VIEW_ID_PT ? newColumns : prevState.columnsPT,
        columnsPV:
          user.viewId === VIEW_ID_PV ? newColumns : prevState.columnsPV,
        columnsKanto:
          user.viewId === VIEW_ID_54 ? newColumns : prevState.columnsKanto,
        columnsFukuokaKumamoto:
          user.viewId === VIEW_ID_5253
            ? newColumns
            : prevState.columnsFukuokaKumamoto,
        columnsSite:
          user.viewId !== VIEW_ID_ALL_FACTORY &&
          user.viewId !== VIEW_ID_PT &&
          user.viewId !== VIEW_ID_PV &&
          user.viewId !== VIEW_ID_54 &&
          user.viewId !== VIEW_ID_5253
            ? newColumns
            : prevState.columnsSite,
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const updateColumnsOrderAndVisibility = (
    columnVisibility: any,
    columnOrder: any
  ) => {
    const columns = getColumns(user.viewId);
    // console.log("columns", columns, "columnVisibility", columnVisibility);
    const newColumns = columns.map((column: Columns) => {
      const newColumn = { ...column };
      newColumn.isShow = columnVisibility[column.columnId];
      return newColumn;
    });
    const sortedColumns = newColumns.sort((a: any, b: any) => {
      const indexA = columnOrder.indexOf(a.columnId);
      const indexB = columnOrder.indexOf(b.columnId);
      return indexA - indexB;
    });
    // console.log("Dnd sortedColums", sortedColumns, "user.viewId", user.viewId);
    setUser((prevState: User) => {
      const newUser = {
        ...prevState,
        columnsAllFactory:
          user.viewId === VIEW_ID_ALL_FACTORY
            ? sortedColumns
            : prevState.columnsAllFactory,
        columnsPT:
          user.viewId === VIEW_ID_PT ? sortedColumns : prevState.columnsPT,
        columnsPV:
          user.viewId === VIEW_ID_PV ? sortedColumns : prevState.columnsPV,
        columnsKanto:
          user.viewId === VIEW_ID_54 ? sortedColumns : prevState.columnsKanto,
        columnsFukuokaKumamoto:
          user.viewId === VIEW_ID_5253
            ? sortedColumns
            : prevState.columnsFukuokaKumamoto,
        columnsSite:
          user.viewId !== VIEW_ID_ALL_FACTORY &&
          user.viewId !== VIEW_ID_PT &&
          user.viewId !== VIEW_ID_PV &&
          user.viewId !== VIEW_ID_54 &&
          user.viewId !== VIEW_ID_5253
            ? sortedColumns
            : prevState.columnsSite,
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  return {
    updateColumnsOrder,
    updateColumnsVisibility,
    updateColumnsOrderAndVisibility,
  };
};
